%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 85449c2ea301fc54091646f096d9e4dc, type: 3}
  m_Name: HammerStorm
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 0}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 7489370104637420957, guid: 73c526bbb006fde49a6978e33b9c6786,
    type: 3}
  castAuraScale: 0.4
  castAuraYOffset: 0.5
  attachCastAuraToCaster: 0
  castSound: {fileID: 0}
  castSoundVolume: 0.2
  soundBeforeChannel: {fileID: 8300000, guid: 7994f284bb25ca64fa21bb890b0e5e98, type: 3}
  beforeChannelSoundDelay: 0
  soundAfterChannel: {fileID: 8300000, guid: 964fdba38affb6b458daf089802e5431, type: 3}
  afterChannelSoundDelay: 0
  animation: 0
  animationVariation: 42
  castDelay: 520
  animationSpeed: 1.6
  animationDuration: 1.2
  skipCooldownOnChannel: 0
  spellName: Hammer Storm
  description: "Deal <b>43</b> damage to all enemy targets within <b>5</b> yards.
    \n\nIf this deals damage, your next <B>Mystical Brilliance</b> within <b>6</b>
    seconds will be an instant cast."
  icon: {fileID: 2800000, guid: 3a49796b3a7ff7242925ec54ec929135, type: 3}
  usableBy: 0d000000
  cooldown: 6
  castTime: 0
  isCastInterruptible: 1
  channelTime: 0
  isOnGlobalCooldown: 1
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 0
  useKeyboardForFacing: 0
  spellType: {fileID: 11400000, guid: 80cddad32b4f07e4bbf640afdccb32f4, type: 2}
  spellKey: 100033
  alwaysCastableSpell: 0
  luaScript: {fileID: 4900000, guid: 325d4cf26adb6964f815bb94c86c9b1b, type: 3}
